module.exports = __webpack_public_path__ + "img/Marco.cd6d9d7f.png";